var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-fill",
    d: "M3.475 2.5L2.5 3.0125V18.0125L3.475 18.5375L14.725 11.0375V10L3.475 2.5ZM3.75 16.85V4.1875L13.25 10.525L3.75 16.85Z",
    fill: "#CE1111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 18.3537L18.475 11.0375V9.99997L7.5 2.68372V4.18747L17 10.525L7.5 16.85V18.3537Z",
    fill: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlay);
export default __webpack_public_path__ + "static/media/bluePlay.815705ed4c9a3d5338b04a8caa93cdc7.svg";
export { ForwardRef as ReactComponent };